var React = require('react');

function Chat24 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 21a9.995 9.995 0 0 1-4.989-1.342.493.493 0 0 0-.379-.051l-4.425 1.186 1.186-4.425a.502.502 0 0 0-.051-.379A9.995 9.995 0 0 1 1 11C1 5.486 5.486 1 11 1s10 4.486 10 10-4.486 10-10 10m0-21C4.935 0 0 4.935 0 11c0 1.849.475 3.679 1.373 5.308L.017 21.371a.504.504 0 0 0 .129.483.505.505 0 0 0 .483.129l5.063-1.356A11.012 11.012 0 0 0 11 22c6.065 0 11-4.935 11-11S17.065 0 11 0","fill":"#fff","fillRule":"evenodd"}));
}

Chat24.defaultProps = {"height":"22","width":"22","viewBox":"0 0 22 22"};

module.exports = Chat24;

Chat24.default = Chat24;
